import { Modal } from 'react-bootstrap'
import { BasicButton } from '../../../widgets/components/UI/BasicButton'
import { useIntl } from 'react-intl'
import { ToolTipUI } from '../../../widgets/components/UI/ToolTipUI'

export const OtpAccessModal = ({
  setAccessModal,
  accessModal,
  onAccess,
  accessLoading,
  AccessId,
  otp,
  setOtp,
  email,
  heading,
  labelText,
  paraText,
  otpErr,
  setOtpErr,
}: {
  setAccessModal: (value: boolean) => void
  accessModal: boolean
  onAccess: any
  accessLoading: boolean
  AccessId: string
  otp: string
  setOtp: (value: string) => void
  email: string
  heading: string
  labelText: string
  paraText: string
  otpErr: boolean
  setOtpErr: (value: boolean) => void
}) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <Modal
        show={accessModal}
        onHide={() => setAccessModal(false)}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({ id: heading })}</h2>
        </Modal.Header>
        <Modal.Body>
          <div className='form-label fs-5 mb-5'>{paraText}</div>
          <div>
            <label htmlFor='uploadLink' className='form-label'>
              {formatMessage({ id: labelText })}
            </label>
            <ToolTipUI tooltipText={formatMessage({ id: 'GLOBAL.TOOLTIP.DATAROOM.PREVIEW.OTP' })} />
            <input
              type='text'
              className={` ${otpErr
                  ? 'form-control border border-danger font-size-13 font-weight-400'
                  : 'form-control font-size-13 font-weight-400'
                }`}
              placeholder={formatMessage({ id: 'Enter your otp here' })}
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value)
                setOtpErr(false)
              }}
            />
            {otpErr && (
              <p className='text-danger'>{formatMessage({ id: 'Error : Enter otp to proceed ' })}</p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <BasicButton
            height='44px'
            border='none'
            color='#F5F8FA'
            textColor='#7E8299'
            padding='12px 16px'
            onClick={() => {
              setAccessModal(false)
              setOtp('')
            }}
            buttonText='Cancel'
            minWidth={56}
          />

          <BasicButton
            height='44px'
            border='1px solid #4776E6'
            color='#4776E6'
            textColor='white'
            padding='12px 24px'
            onClick={() => {
              onAccess(AccessId, undefined, email, otp)
            }}
            buttonText='Confirm'
            minWidth={56}
            loading={accessLoading}
            disabled={accessLoading}
          /> */}
          <div className='d-flex flex-md-row flex-column justify-content-md-end gap-2 w-100'>
            <BasicButton
              onClick={() => {
                setAccessModal(false)
                setOtp('')
              }}
              buttonText='Cancel'
              customClass='w-md-auto w-100 custom-button-property bg-light text-muted order-2 order-md-1'
            />

            <BasicButton
              onClick={() => {
                onAccess(AccessId, undefined, email, otp)
              }}
              buttonText='Confirm'
              customClass='w-md-auto w-100 custom-button-property bg-primary text-white order-1 order-md-2'
              loading={accessLoading}
              disabled={accessLoading}
            />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
